module.exports = __webpack_public_path__ + "assets/img/logo_leaf.67077239.png";